import { SURCHARGES_CATEGORY } from '../../checklistCategories';
import { formatBooleanDataPointValue, formatContextDate, formatMoney } from '../../shared/format';
import type { ApprovalQueueItem } from '../../types';

import type { SurchargeTableRow, SurchargesChecklistRow } from './types';

export function buildSurchargesQueueItem(row: SurchargesChecklistRow): ApprovalQueueItem {
  return {
    categoryId: SURCHARGES_CATEGORY.id,
    categoryLabel: SURCHARGES_CATEGORY.label,
    description: `${row.name} surcharge rule requires review.`,
    details: row.details,
    id: row.id,
    title: row.name,
  };
}

export function buildSurchargeTableQueueItem(row: SurchargeTableRow): ApprovalQueueItem {
  return {
    categoryId: SURCHARGES_CATEGORY.id,
    categoryLabel: SURCHARGES_CATEGORY.label,
    description: `${row.name} surcharge requires review.`,
    details: [
      { label: 'Period', value: `${formatContextDate(row.fromDate)} – ${formatContextDate(row.toDate)}` },
      { label: 'Converted Cost', value: formatMoney(row.convertedCost, row.currencyCode) },
      { label: 'Surcharge Price', value: formatMoney(row.surchargePrice, row.currencyCode) },
      { label: 'Accumulate', value: formatBooleanDataPointValue({ dataAvailable: true, enabled: row.accumulate }) },
      {
        label: 'Inside Travel Period',
        value: formatBooleanDataPointValue({
          dataAvailable: row.insideTravelPeriod !== null,
          enabled: row.insideTravelPeriod ?? false,
        }),
      },
      {
        label: 'Blackout Overlap',
        value: formatBooleanDataPointValue({
          dataAvailable: row.blackoutOverlap !== null,
          enabled: row.blackoutOverlap ?? false,
        }),
      },
    ],
    id: row.id,
    title: row.name,
  };
}

export function getSurchargesSearchText(row: SurchargesChecklistRow) {
  return [row.name, row.field, row.statusLabel].join(' ');
}

export function getSurchargeTableSearchText(row: SurchargeTableRow) {
  return [row.name, row.statusLabel].join(' ');
}
